import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import forEach from 'lodash/forEach'
import shuffle from 'lodash/shuffle'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import MuiLink from '@material-ui/core/Link'
import Toolbar from '@material-ui/core/Toolbar'
import MoreIcon from '@material-ui/icons/ChevronRight'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import ProjectSummaryCard from '../ProjectSummaryCard'
import data from '../../data/projects.json'

const PageContainer = styled.main`
	margin: 2vh 2vw;
`
const GroupingControlBar = styled(Toolbar).attrs(() => ({
	disableGutters: true,
}))`
	&.MuiToolbar-root {
		justify-content: space-between;
	}
`
const CitySeparator = styled.div`
	margin-bottom: 24px;
	h2 {
		// color: rgba(0, 0, 0, 0.7);
		font-weight: 600;
		font-size: 24px;
		text-transform: capitalize;
	}
	h3 {
		font-size: 16px;
	}
	hr {
		height: 1px;
		background-color: #979797;
		border: none;
	}
	.city-title {
		display: flex;
		align-items: baseline;
	}
`
export const ProjectCardsContainer = styled.div`
	display: flex;
	justify-content: space-around;
	flex-wrap: nowrap;
	& > * {
		margin-right: 24px;
		flex: 350px 1 0;
	}
	@media (max-width: 880px) {
		& > * {
			margin-right: 0;
			margin-bottom: 12px;
			width: 85vw;
		}
	}
`

const facetOptions = [
	{name: 'citiesOfOperation', label: 'Cities'},
	{name: 'pathways', label: 'Pathways'},
]

function shuffleProjects(raw) {
	const {groupedHits, facets} = raw
	const shuffledHits = {}
	forEach(groupedHits, (groupedValues, groupKey) => {
		shuffledHits[groupKey] = {}
		forEach(groupedValues, (arr, key) => {
			shuffledHits[groupKey][key] = shuffle(arr)
		})
	})
	return {shuffledHits, facets}
}

export default function ProjectsPage() {
	const [selectedFacet, setSelectedFacet] = useState('citiesOfOperation')
	const {shuffledHits, facets} = shuffleProjects(data)

	const matchesMD = useMediaQuery(theme => theme.breakpoints.up('md'))
	const matchesLG = useMediaQuery(theme => theme.breakpoints.up('lg'))
	const matchesXL = useMediaQuery(theme => theme.breakpoints.up('xl'))
	let maxCardCount = 1
	if (matchesMD) maxCardCount++
	if (matchesLG) maxCardCount++
	if (matchesXL) maxCardCount++

	const selectedFacetsData = facets[selectedFacet]

	return (
		<PageContainer>
			<GroupingControlBar>
				<div>
					Group Projects by:{' '}
					<ButtonGroup variant="outlined">
						{facetOptions.map(option => (
							<Button
								key={option.name}
								color={
									selectedFacet === option.name
										? 'primary'
										: 'default'
								}
								onClick={() => setSelectedFacet(option.name)}
							>
								{option.label}
							</Button>
						))}
					</ButtonGroup>
				</div>
			</GroupingControlBar>

			{Object.keys(selectedFacetsData).map(facetKey => (
				<React.Fragment key={facetKey}>
					<CitySeparator>
						<div className="city-title">
							<h2>{facetKey}</h2>
							<MuiLink
								component={Link}
								to={{
									pathname: '/search',
									search: `?refinementList[${encodeURIComponent(
										selectedFacet
									)}][0]=${encodeURIComponent(facetKey)}`,
								}}
							>
								view all projects <MoreIcon />
							</MuiLink>
						</div>
						<hr />
					</CitySeparator>

					<ProjectCardsContainer>
						{shuffledHits[selectedFacet][facetKey]
							.slice(0, maxCardCount)
							.map(project => (
								<Link
									to={`/project/${project.projectId}`}
									key={project.projectId}
								>
									<ProjectSummaryCard projectData={project} />
								</Link>
							))}
					</ProjectCardsContainer>
				</React.Fragment>
			))}
		</PageContainer>
	)
}
